import { ArrowLeft01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
const BackButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate(-1)}
      variant="outlined"
      size="large"
      startIcon={<HugeiconsIcon icon={ArrowLeft01Icon} />}
    >
      Regresar
    </Button>
  );
};

export default BackButton;
